import { render, staticRenderFns } from "./formData.vue?vue&type=template&id=684cbcc6&scoped=true&"
import script from "./formData.vue?vue&type=script&lang=js&"
export * from "./formData.vue?vue&type=script&lang=js&"
import style0 from "./formData.vue?vue&type=style&index=0&id=684cbcc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684cbcc6",
  null
  
)

export default component.exports